export default "__VITE_ASSET__BahX7Y1v__"